import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'getBindLabel',
    standalone: false
})
export class GetBindLabelPipe<T> implements PipeTransform {
    transform( currentItem: string, items: T[], bindValue: string, bindLabel: string): string {
        const matchedItem = items?.find(item => item[bindValue] == currentItem);
        if (!matchedItem) {
            return '';
        }
        return matchedItem?.[bindLabel] || currentItem;
    }
}